import { render, staticRenderFns } from "./BoardUser.vue?vue&type=template&id=fb64386c"
import script from "./BoardUser.vue?vue&type=script&lang=js"
export * from "./BoardUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports